module.exports = __webpack_public_path__ + "static/img/z6.79702b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z6.png
// module id = Mj/6
// module chunks = 0